module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_sns_05-03ae9ea962db980c661adebc1cc15264.jpg";